import { useRef, useState, useId } from 'react';
import { useFloating, autoUpdate, offset, flip, shift, useHover, useFocus, useDismiss, useRole, useInteractions, FloatingArrow, arrow } from '@floating-ui/react';
import { TipHover, TipBubble } from './Tooltip.styled';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/**
 * The `Tooltip` atom renders a small, floating text box that provides
 * additional information about an element when the user hovers over
 */
export const Tooltip = _ref => {
  let {
    text,
    placement = 'bottom',
    children,
    ...rest
  } = _ref;
  const [isOpen, setIsOpen] = useState(false);
  const tipId = useId();
  const arrowRef = useRef(null);
  const isTopOrBottomPlaced = placement.search('top') > -1 || placement.search('bottom') > -1;
  const arrowPadding = isTopOrBottomPlaced ? 40 : 10;
  const {
    x,
    y,
    strategy,
    refs,
    context
  } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    middleware: [offset(7), flip(), shift(), arrow({
      element: arrowRef,
      padding: arrowPadding
    })],
    whileElementsMounted: autoUpdate,
    placement
  });
  const hover = useHover(context, {
    move: false
  });
  const focus = useFocus(context);
  const dismiss = useDismiss(context);
  const role = useRole(context, {
    role: 'tooltip'
  });

  // Merge all the interactions into prop getters
  const {
    getReferenceProps,
    getFloatingProps
  } = useInteractions([hover, focus, dismiss, role]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TipHover, {
      ref: refs.setReference,
      ...getReferenceProps(),
      tabIndex: 0,
      role: "button",
      ...rest,
      children: children
    }), isOpen && /*#__PURE__*/_jsxs(TipBubble, {
      ref: refs.setFloating,
      id: tipId,
      position: strategy,
      top: y ? `${y}px` : 0,
      left: x ? `${x}px` : 0,
      ...getFloatingProps(),
      children: [/*#__PURE__*/_jsx(FloatingArrow, {
        ref: arrowRef,
        context: context,
        fill: "#312f2d"
      }), text]
    })]
  });
};